var interval = setInterval(function () {
  var $oneTime = $('input[data-radio-type="one_time_purchase"]');
  var $subscribe = $('input[data-radio-type="selling_plan_group"]');
  var $qtyRadio = $('.quantiy-box.active input.qty-radio');
  if ($oneTime.length && $subscribe.length && $qtyRadio.length) {
    $oneTime.prop('checked', false);
    $subscribe.prop('checked', true).trigger('change');
    $subscribe.closest('label').get(0).click();
    $('.shopify_subscriptions_app_block_label_children li:first label').get(0).click();
    $qtyRadio.get(0).click();
    $qtyRadio.prop('checked', true).trigger('change');
    clearInterval(interval);
  }
}, 200);

function getBasePrice() {
    var raw = $('body').attr('data-price');
    if (!raw) return null;
    return parseFloat(raw.toString().replace(/[^0-9.-]+/g, ''));
}

function updateVariantImages(dataValue) {
    if (!dataValue) return;
    var $option = $(`select.variant--id--loop option[vra-title='${dataValue}']`);
    var price = $option.attr('data-price');
    var cprice = $option.attr('data-cprice');
    $('body').attr('data-price', price);
    $('body').attr('data-cprice', cprice);
    var $boxes = $('.cust-quantity.nerve_matrix .quantiy-box');
    if ($boxes.length >= 3) {
        $boxes.eq(0).find('img').attr('src', $option.attr('var-image1'));
        $boxes.eq(1).find('img').attr('src', $option.attr('var-image12'));
        $boxes.eq(2).find('img').attr('src', $option.attr('var-image3'));
    }
}

// On flavor input click
$('body').on('click', '.flavor-block input', function () {
    $('.flavor-block .form__label').removeClass('active');
    $(this).parent().find('.form__label').addClass('active');
    var dataVariantId = $(this).attr('data-variant-id');
    var dataValue = $(this).attr('data--value');
    updateVariantImages(dataValue);
    $('product-form.product-form input.product-variant-id').val(dataVariantId);
    setTimeout(updateQuantiyBoxPrices, 200);
    var mediaId = $(this).attr('data-media-id');
    if (mediaId && !mediaId.endsWith('-')) {
        var mediaGallery = document.querySelector('media-gallery');
        if (mediaGallery) mediaGallery.setActiveMedia(mediaId, true);
    }
});

// Increase quantity
$('.selected-summary .increase').on('click', function() {
    var $input = $(this).siblings('.quantity-input');
    $input.val(parseInt($input.val()) + 1);
});

// Decrease quantity
$('.selected-summary').on('click', '.decrease', function() {
    var $input = $(this).siblings('.quantity-input');
    var currentVal = parseInt($input.val());
    if (currentVal > 0) $input.val(currentVal - 1);
});

function distributeQuantity(totalQuantity) {
    var $variantInputs = $('.selected-summary li.variant-item .quantity-input');
    var variantCount = $variantInputs.length;
    if (variantCount === 0) return;
    var quantities = [];
    var remaining = totalQuantity;
    for (var i = 0; i < variantCount; i++) {
        if (i === variantCount - 1) {
            quantities.push(remaining);
        } else {
            var assign = Math.ceil(remaining / 2);
            quantities.push(assign);
            remaining -= assign;
        }
    }
    $variantInputs.each(function(index) {
        $(this).val(quantities[index]).attr('min', 0);
    });
}

$('body').on('click', '.cust-quantity.nerve_matrix .quantiy-box', function () {
    distributeQuantity(parseInt($(this).find('input').val()));
});

// Add to cart
$('body').on('click', '.custom__buy_button', function () {
    var json_obj = [];
    var sellingPlanId = parseInt($('input.selected-selling-plan-id').attr('value'));
    $(".selected-summary .variant-item").each(function () {
        var item = {
            id: parseInt($(this).attr("data-variant-id")),
            quantity: parseInt($(this).find('input.quantity-input').val())
        };
        if (!isNaN(sellingPlanId)) item.selling_plan = sellingPlanId;
        json_obj.push(item);
    });
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: json_obj },
        dataType: "json",
        success: function (data) {
            refreshCartDrawer();
            $.getJSON('/cart.js', function (cart) {
                $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);
            });
        },
        error: function(xhr, status, error) {
            console.error("Cart add failed:", error);
        }
    });
});

function refreshCartDrawer() {
    let drawerItems = document.querySelector("cart-drawer-items");
    const cartDrawer = document.querySelector("cart-drawer");
    const checkoutBtn = document.querySelector(".cart__checkout-button");
    if (cartDrawer) {
        cartDrawer.classList.remove("is-empty");
        checkoutBtn?.removeAttribute("disabled");
        cartDrawer.querySelector(".drawer__inner-empty")?.remove();
        const contentsForm = document.querySelector(".cart__contents");
        if (contentsForm) contentsForm.style.display = "block";
    }
    if (!drawerItems) {
        drawerItems = document.createElement("cart-drawer-items");
        document.querySelector(".drawer__header")?.insertAdjacentElement("afterend", drawerItems);
    }
    const itemsComp = document.querySelector("cart-drawer-items");
    if (typeof itemsComp?.onCartUpdate === "function") itemsComp.onCartUpdate();
    if (typeof cartDrawer?.open === "function") cartDrawer.open();
}

$('body').on('click', '.shopify_subscriptions_app_block_label', function () {
    $('.shopify_subscriptions_app_block_label input').prop('checked', false);
    var $input = $(this).find('input');
    $input.prop('checked', true);
    if ($input.attr('data-radio-type') === 'selling_plan_group') {
        $('.shopify_subscriptions_app_block_label_children').show();
    } else {
        $('.selected-selling-plan-id').val('');
        $('.shopify_subscriptions_app_block_label_children').hide();
    }
});

$('body').on('click', '.shopify_subscriptions_app_block_label_children ul li', function () {
    $('.shopify_subscriptions_app_block_label_children ul li label').removeClass('active');
    $(this).find('label').addClass('active');
    $('.selected-selling-plan-id').val($(this).find('input').attr('data-selling-plan-id'));
    setTimeout(updateQuantiyBoxPrices, 200);
});
function getcompPrice() {
    var cpp = $('body').attr('data-cprice');
    if (!cpp) return null;
    return parseFloat(cpp.toString().replace(/[^0-9.-]+/g, ''));
}
function updateQuantiyBoxPrices() {
    var $checkedRadio = $('.shopify_subscriptions_app_block_purchase_options input[type="radio"]:checked');
    var isOneTime = $checkedRadio.length && $checkedRadio.attr('data-radio-type') === 'one_time_purchase';
    var basePrice = getBasePrice();
    if (!basePrice) return;
    var labelText = $('.shopify_subscriptions_app_block_label_children label.active').text();
    var additionalDiscount = labelText.includes('10%') ? 10 : labelText.includes('5%') ? 5 : 0;

    $('.cust-quantity.nerve_matrix .quantiy-box').each(function(index) {
        var $box = $(this);
        var $input = $box.find('input.qty-radio');
        var quantityValue = parseFloat($input.val()) || 1;
        var finalAmount;
        var ragcpp = getcompPrice();
        var ragAmount = ragcpp * quantityValue;

        if (isOneTime) {
            var discountPercent = (index === 0) ? 5 : 8;
            finalAmount = (basePrice - basePrice * discountPercent / 100) * quantityValue;
        } else {
            var discountPercent = (quantityValue <= 3) ? 5 : 8;
            var amountWithQuantity = (basePrice - basePrice * discountPercent / 100) * quantityValue;
            finalAmount = amountWithQuantity - amountWithQuantity * additionalDiscount / 100;
        }

        $input.attr('data-final-amount', finalAmount);
        $box.find('.qty-box-bottom span.boxprice').text(`$${finalAmount.toFixed(2)}`);
        $box.find('.qty-box-bottom span.ragprice').text(`$${ragAmount.toFixed(2)}`);
    });
}

$(document).ready(function() {
    var $selected = $('.flavor-block input:checked');
    if ($selected.length) updateVariantImages($selected.attr('data--value'));
    var $activeBox = $('.cust-quantity.nerve_matrix .quantiy-box.active');
    if ($activeBox.length) distributeQuantity(parseInt($activeBox.find('input').val()));
    setTimeout(updateQuantiyBoxPrices, 200);
});

$(document).on(
    'click input',
    '.shopify_subscriptions_app_block_purchase_options input[type="radio"], ' +
    '.shopify_subscriptions_app_block_label_children input[type="radio"], ' +
    '.cust-quantity.nerve_matrix .quantiy-box input.qty-radio, ' +
    '.cust-quantity.nerve_matrix .quantiy-box input[type="number"]',
    function() { setTimeout(updateQuantiyBoxPrices, 200); }
);
